import React, {useState, useContext, useEffect} from 'react'

import { TextField, Button, Autocomplete } from '@mui/material';

import { FirebaseContext } from '../../Services/firebase'

import Dialog from '@mui/material/Dialog';
import { PDFViewer } from '@react-pdf/renderer';
import DialogContent from '@mui/material/DialogContent';

import { getCustomerList } from '../../Utils/getCustomerList';

import PdfInvoicesWeek from './PdfInvoicesWeek';

export default function InvoicesWeek(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [value, setValue] = useState('clients');
    const [inputValue, setInputValue] = React.useState('');

    const [WeekState, setWeekState] = React.useState('');
    const [WeekState2, setWeekState2] = React.useState('');
    const [WeekState3, setWeekState3] = React.useState('');
    const [WeekState4, setWeekState4] = React.useState('');
    const [WeekState5, setWeekState5] = React.useState('');
    const [WeekState6, setWeekState6] = React.useState('');

    const [Exist, setExist] = useState(false);
    const [open, setOpen] = React.useState(false);

    const [Lundi, setLundi] = useState([]);
    const [Mardi, setMardi] = useState([]);
    const [Mercredi, setMercredi] = useState([]);
    const [Jeudi, setJeudi] = useState([]);
    const [Vendredi, setVendredi] = useState([]);
    const [Samedi, setSamedi] = useState([]);
    const [Dimanche, setDimanche] = useState([]);

    const [Lundi2, setLundi2] = useState([]);
    const [Mardi2, setMardi2] = useState([]);
    const [Mercredi2, setMercredi2] = useState([]);
    const [Jeudi2, setJeudi2] = useState([]);
    const [Vendredi2, setVendredi2] = useState([]);
    const [Samedi2, setSamedi2] = useState([]);
    const [Dimanche2, setDimanche2] = useState([]);

    const [Lundi3, setLundi3] = useState([]);
    const [Mardi3, setMardi3] = useState([]);
    const [Mercredi3, setMercredi3] = useState([]);
    const [Jeudi3, setJeudi3] = useState([]);
    const [Vendredi3, setVendredi3] = useState([]);
    const [Samedi3, setSamedi3] = useState([]);
    const [Dimanche3, setDimanche3] = useState([]);

    const [Lundi4, setLundi4] = useState([]);
    const [Mardi4, setMardi4] = useState([]);
    const [Mercredi4, setMercredi4] = useState([]);
    const [Jeudi4, setJeudi4] = useState([]);
    const [Vendredi4, setVendredi4] = useState([]);
    const [Samedi4, setSamedi4] = useState([]);
    const [Dimanche4, setDimanche4] = useState([]);

    const [Lundi5, setLundi5] = useState([]);
    const [Mardi5, setMardi5] = useState([]);
    const [Mercredi5, setMercredi5] = useState([]);
    const [Jeudi5, setJeudi5] = useState([]);
    const [Vendredi5, setVendredi5] = useState([]);
    const [Samedi5, setSamedi5] = useState([]);
    const [Dimanche5, setDimanche5] = useState([]);

    const [Lundi6, setLundi6] = useState([]);
    const [Mardi6, setMardi6] = useState([]);
    const [Mercredi6, setMercredi6] = useState([]);
    const [Jeudi6, setJeudi6] = useState([]);
    const [Vendredi6, setVendredi6] = useState([]);
    const [Samedi6, setSamedi6] = useState([]);
    const [Dimanche6, setDimanche6] = useState([]);

    

    useEffect(() => {
            getCustomerList(firebase, props.UserSession.uid, setCustomers)
        }, [firebase, props.UserSession.uid])

    const checkChoices = (event) => {
        setWeekState(event.target.value)
    }

    const checkChoices2 = (event) => {
        setWeekState2(event.target.value)
    }

    const checkChoices3 = (event) => {
        setWeekState3(event.target.value)
    }

    const checkChoices4 = (event) => {
        setWeekState4(event.target.value)
    }

    const checkChoices5 = (event) => {
        setWeekState5(event.target.value)
    }

    const checkChoices6 = (event) => {
        setWeekState6(event.target.value)
    }

    const getRecap = () => {
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "1").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                console.log(result.data())
                setLundi(Lundi => [...Lundi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "2").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMardi(Mardi => [...Mardi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "3").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMercredi(Mercredi => [...Mercredi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "4").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setJeudi(Jeudi => [...Jeudi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "5").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setVendredi(Vendredi => [...Vendredi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "6").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setSamedi(Samedi => [...Samedi, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, "7").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setDimanche(Dimanche => [...Dimanche, result.data()])
            })
        })

        // -------- SECOND WEEK ----------

        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "1").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                console.log(result.data())
                setLundi2(Lundi2 => [...Lundi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "2").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMardi2(Mardi2 => [...Mardi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "3").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMercredi2(Mercredi2 => [...Mercredi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "4").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setJeudi2(Jeudi2 => [...Jeudi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "5").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setVendredi2(Vendredi2 => [...Vendredi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "6").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setSamedi2(Samedi2 => [...Samedi2, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState2, "7").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setDimanche2(Dimanche2 => [...Dimanche2, result.data()])
            })
        })

        // -------- THIRD WEEK ----------

        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "1").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                console.log(result.data())
                setLundi3(Lundi3 => [...Lundi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "2").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMardi3(Mardi3 => [...Mardi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "3").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMercredi3(Mercredi3 => [...Mercredi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "4").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setJeudi3(Jeudi3 => [...Jeudi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "5").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setVendredi3(Vendredi3 => [...Vendredi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "6").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setSamedi3(Samedi3 => [...Samedi3, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState3, "7").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setDimanche3(Dimanche3 => [...Dimanche3, result.data()])
            })
        })

        // -------- FOURTH WEEK ----------

        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "1").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                console.log(result.data())
                setLundi4(Lundi4 => [...Lundi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "2").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMardi4(Mardi4 => [...Mardi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "3").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setMercredi4(Mercredi4 => [...Mercredi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "4").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setJeudi4(Jeudi4 => [...Jeudi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "5").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setVendredi4(Vendredi4 => [...Vendredi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "6").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setSamedi4(Samedi4 => [...Samedi4, result.data()])
            })
        })
        firebase.getCustomerChoices(props.UserSession.uid, value, WeekState4, "7").get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(result => {
                setDimanche4(Dimanche4 => [...Dimanche4, result.data()])
            })
        })

        // -------- FIFTH WEEK ----------

        if (WeekState5) {
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "1").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    console.log(result.data())
                    setLundi5(Lundi5 => [...Lundi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "2").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setMardi5(Mardi5 => [...Mardi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "3").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setMercredi5(Mercredi5 => [...Mercredi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "4").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setJeudi5(Jeudi5 => [...Jeudi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "5").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setVendredi5(Vendredi5 => [...Vendredi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "6").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setSamedi5(Samedi5 => [...Samedi5, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState5, "7").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setDimanche5(Dimanche5 => [...Dimanche5, result.data()])
                })
            })
        }

        // -------- SIX WEEK ----------

        if (WeekState6) {
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "1").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    console.log(result.data())
                    setLundi6(Lundi6 => [...Lundi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "2").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setMardi6(Mardi6 => [...Mardi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "3").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setMercredi6(Mercredi6 => [...Mercredi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "4").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setJeudi6(Jeudi6 => [...Jeudi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "5").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setVendredi6(Vendredi6 => [...Vendredi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "6").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setSamedi6(Samedi6 => [...Samedi6, result.data()])
                })
            })
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState6, "7").get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(result => {
                    setDimanche6(Dimanche6 => [...Dimanche6, result.data()])
                })
            })
        }

        setExist(true)
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setValue('')

        setLundi([])
        setMardi([])
        setMercredi([])
        setJeudi([])
        setVendredi([])
        setSamedi([])
        setDimanche([])

        setLundi2([])
        setMardi2([])
        setMercredi2([])
        setJeudi2([])
        setVendredi2([])
        setSamedi2([])
        setDimanche2([])

        setLundi3([])
        setMardi3([])
        setMercredi3([])
        setJeudi3([])
        setVendredi3([])
        setSamedi3([])
        setDimanche3([])

        setLundi4([])
        setMardi4([])
        setMercredi4([])
        setJeudi4([])
        setVendredi4([])
        setSamedi4([])
        setDimanche4([])

        setLundi5([])
        setMardi5([])
        setMercredi5([])
        setJeudi5([])
        setVendredi5([])
        setSamedi5([])
        setDimanche5([])

        setLundi6([])
        setMardi6([])
        setMercredi6([])
        setJeudi6([])
        setVendredi6([])
        setSamedi6([])
        setDimanche6([])
    };

    return(
        <div style={{display: "flex", flexDirection: "column"}}>
            <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Customers}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="clients" />}
                />
            <TextField required type="text" name="week" label="numéro de semaine 1" id="week" value={WeekState} onChange={checkChoices} style={{width: "15vw", marginTop: "2vh"}} />
            <TextField required type="text" name="week" label="numéro de semaine 2" id="week" value={WeekState2} onChange={checkChoices2} style={{width: "15vw", marginTop: "2vh"}} />
            <TextField required type="text" name="week" label="numéro de semaine 3" id="week" value={WeekState3} onChange={checkChoices3} style={{width: "15vw", marginTop: "2vh"}} />
            <TextField required type="text" name="week" label="numéro de semaine 4" id="week" value={WeekState4} onChange={checkChoices4} style={{width: "15vw", marginTop: "2vh"}} />
            <TextField required type="text" name="week" label="numéro de semaine 5" id="week" value={WeekState5} onChange={checkChoices5} style={{width: "15vw", marginTop: "2vh"}} />
            <TextField required type="text" name="week" label="numéro de semaine 6" id="week" value={WeekState6} onChange={checkChoices6} style={{width: "15vw", marginTop: "2vh"}} />

            <Button onClick={getRecap} style={{marginTop: "2vh", width: "10vh"}} variant="contained">Afficher</Button>
            <div style={{display: "flex", flexDirection: "column", marginLeft: "2vw"}}>
                {
                    Exist === false ? null :
                    <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth={'lg'}
                    >
                        <DialogContent>
                            <PDFViewer style={{width: "90vw", height: "80vh"}}>
                                <PdfInvoicesWeek
                                client={value}
                                lundi={Lundi}
                                mardi={Mardi}
                                mercredi={Mercredi}
                                jeudi={Jeudi}
                                vendredi={Vendredi}
                                samedi={Samedi}
                                dimanche={Dimanche}

                                lundi2={Lundi2}
                                mardi2={Mardi2}
                                mercredi2={Mercredi2}
                                jeudi2={Jeudi2}
                                vendredi2={Vendredi2}
                                samedi2={Samedi2}
                                dimanche2={Dimanche2}

                                lundi3={Lundi3}
                                mardi3={Mardi3}
                                mercredi3={Mercredi3}
                                jeudi3={Jeudi3}
                                vendredi3={Vendredi3}
                                samedi3={Samedi3}
                                dimanche3={Dimanche3}

                                lundi4={Lundi4}
                                mardi4={Mardi4}
                                mercredi4={Mercredi4}
                                jeudi4={Jeudi4}
                                vendredi4={Vendredi4}
                                samedi4={Samedi4}
                                dimanche4={Dimanche4}

                                lundi5={Lundi5}
                                mardi5={Mardi5}
                                mercredi5={Mercredi5}
                                jeudi5={Jeudi5}
                                vendredi5={Vendredi5}
                                samedi5={Samedi5}
                                dimanche5={Dimanche5}

                                lundi6={Lundi6}
                                mardi6={Mardi6}
                                mercredi6={Mercredi6}
                                jeudi6={Jeudi6}
                                vendredi6={Vendredi6}
                                samedi6={Samedi6}
                                dimanche6={Dimanche6}/>

                            </PDFViewer>
                        </DialogContent>
                    </Dialog>
                }
            </div>
        </div>
    )
}